import React, {useContext, useRef, useState} from 'react';
import {CircularProgress} from "@mui/material";
import CustomizedDialogs from "./udialog";
import {post} from "./post";
import {ProblemContext} from "../components/Problem";

const FileUpload = ({children}) => {
    const {data:{HTMLBody}} = useContext(ProblemContext);
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [html, setHTML] = useState(null);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];

        if(!file) return;

        setLoading(true);
        const reader = new FileReader();
        reader.onloadend = async () => {
            const {html} = await post({method: "photo", base64: reader.result, HTMLBody});
            setHTML(html);
            setLoading(false);
            fileInputRef.current.remove();
        };
        reader.readAsDataURL(file);
    };

    const onClick = () => {
        const input = document.createElement("input");
        input.style.display = "none";
        input.type = "file";
        input.onchange = handleFileChange;
        input.click();
        fileInputRef.current = input;
    }

    return (
        <div>
            {html && <CustomizedDialogs html={html}/>}
            {loading ? (
                <CircularProgress/>
            ) : (
                <div onClick={onClick}>{children}</div>
            )}
        </div>
    );
};

export default FileUpload;
